import Router from 'next/router'
import NProgress from 'nprogress'
import React, { useEffect } from 'react'
import { createGlobalStyle } from 'styled-components'

const NProgressStyle = createGlobalStyle`
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: #000;
    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
  }
`

export const ProgressIndicator = () => {
  useEffect(() => {
    let timer: NodeJS.Timeout

    const routeChangeStart = () => {
      NProgress.set(0.3)
      NProgress.start()
    }

    const routeChangeComplete = () => {
      clearTimeout(timer)

      timer = setTimeout(() => {
        NProgress.done(true)
      }, 200)
    }

    window.nprogress = NProgress

    Router.events.on('routeChangeStart', routeChangeStart)
    Router.events.on('routeChangeComplete', routeChangeComplete)
    Router.events.on('routeChangeError', routeChangeComplete)

    return () => {
      Router.events.off('routeChangeStart', routeChangeStart)
      Router.events.off('routeChangeComplete', routeChangeComplete)
      Router.events.off('routeChangeError', routeChangeComplete)
    }
  }, [])

  return <NProgressStyle />
}
